import DefaultImages from "./DefaultImages.json";

export const defaultImages = DefaultImages as any;
